import { mainModule } from './main.module';

export const loadAngularJsMainAppShell = (): angular.IModule => mainModule;
